import React, { FC, useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, UseFormOptions } from 'react-hook-form';

import { fc } from 'i18n';
import { ITepOfficer } from 'types/tep';
import Button from 'core/react/general/form/Button';
import { Preloader } from 'components/atoms/preloader';
import { close as closeSign, plus } from 'assets/icons';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { officersModalSelector } from 'core/redux/selectors/tep';
import { ModalWrapper } from 'components/molecules/modal-wrapper';
import { InfoTable } from 'components/organisms/tables/info-table';
import { useOfficersColumns } from 'hooks/tep/leases/useOfficersModals';
import { actions as leaseActions } from 'core/redux/api/veta/tep/leases';
import { actions as officersActions } from 'core/redux/api/veta/tep/officers';

import styles from './styles.module.css';

const FORM_OPTIONS: UseFormOptions<{ phone: string; remarks: string }> = {
  mode: 'onChange',
};

export const OfficersModal: FC = () => {
  const dispatch = useDispatch();

  const { isLoading, error, selected, intent, officers } = useSelector(officersModalSelector);

  const formMethods = useForm<{ phone: string; remarks: string }>(FORM_OPTIONS);

  const columns = useOfficersColumns();

  const { reset } = formMethods;

  const setFormValues = ({ phone, remarks }: ITepOfficer) => {
    reset({ phone, remarks });
  };

  const close = () => {
    dispatch(leaseActions.intent({ intent: null }));
    dispatch(officersActions.cancel());
  };

  const add = () => {
    dispatch(officersActions.intent({ intent: 'add' }));
  };

  const scrollToBottom = () => {
    const table = document.getElementById('officers-table');

    !!table && table.scrollTo({ top: table.scrollHeight + 50, behavior: 'smooth' });
  };

  useEffect(() => {
    !!selected && setFormValues(selected);
  }, [selected]);

  useEffect(() => {
    intent === 'add' && scrollToBottom();
  }, [intent]);

  return (
    <ModalWrapper>
      <FormProvider {...formMethods}>
        <form className={styles.wrapper}>
          <div className={styles.header}>
            <span className={styles.close} onClick={close}>
              <SvgWrapper width={26} height={26} details={closeSign} />
            </span>
            <div className={styles.title}>{fc('Enforcement Officer’s Contact')}</div>
            <Button className={`${styles.addButton}`} disabled={intent === 'add'} onClick={add}>
              <SvgWrapper width={16} height={16} details={plus} color="#79CDD0" />
              <span> {fc('add')}</span>
            </Button>
          </div>
          {/*@ts-ignore*/}
          <InfoTable id="officers-table" height={240} columns={columns} data={officers} />
          <div className={styles.footer}>
            <div className={styles.error}>{error || ''}</div>
            <Button onClick={close} className={`${styles.submit} active`} type="button">
              <span>{fc('close')}</span>
            </Button>
          </div>
        </form>
        {isLoading && <Preloader />}
      </FormProvider>
    </ModalWrapper>
  );
};
